import React from "react"
import _ from "lodash"
import * as Formatter from "utils/Formatter"
import ClassNames from "classnames"
import { QUOTE_FLAG_LIST } from "config/const"

interface Props {
  push: any
  length: number
  Symbol: {
    Symbol: string
    SecurityType: number
    Exchange: number
    NumberOfDecimals: number
  }
}

interface State {}

export default class OrderBook extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
  }

  renderAsk = (index: number) => {
    const { push, Symbol } = this.props
    return (
      <tr>
        <td className="buy-sell-price-cell sell-cell number-cell">
          {Formatter.number(
            _.get(push, `DepthOfAskPrice[${index}].Qty`),
            0,
            "floor",
            false,
            "-",
            true
          )}
        </td>
        <td className="mark-cell" />
        <td className="center-cell">
          <span
            className={ClassNames({
              buy: _.get(push, `DepthOfAskPrice[${index}].Price`),
            })}
          >
            {Formatter.number(
              _.get(push, `DepthOfAskPrice[${index}].Price`),
              Symbol.NumberOfDecimals,
              "floor",
              false,
              "-",
              true
            )}
          </span>
        </td>
        <td className="mark-cell" />
        <td className="buy-sell-price-cell buy-cell number-cell" />
      </tr>
    )
  }

  renderBid = (index: number) => {
    const { push, Symbol } = this.props
    return (
      <tr>
        <td className="buy-sell-price-cell sell-cell number-cell" />
        <td className="mark-cell" />
        <td className="center-cell">
          <span
            className={ClassNames({
              sell: _.get(push, `DepthOfBidPrice[${index}].Price`),
            })}
          >
            {Formatter.number(
              _.get(push, `DepthOfBidPrice[${index}].Price`),
              Symbol.NumberOfDecimals,
              "floor",
              false,
              "-",
              true
            )}
          </span>
        </td>
        <td className="mark-cell" />
        <td className="buy-sell-price-cell buy-cell number-cell">
          {Formatter.number(
            _.get(push, `DepthOfBidPrice[${index}].Qty`),
            0,
            "floor",
            false,
            "-",
            true
          )}
        </td>
      </tr>
    )
  }

  render() {
    const { push, length, Symbol } = this.props
    const finalLength = length

    const CalcOverQty =
      push.DepthOfAskPrice === undefined
        ? push.OverQty
        : _.sumBy(push.DepthOfAskPrice.slice(finalLength, 10), item =>
            _.get(item, "Qty", 0)
          ) + push.OverQty
    const CalcUnderQty =
      push.DepthOfBidPrice === undefined
        ? push.UnderQty
        : _.sumBy(push.DepthOfBidPrice.slice(finalLength, 10), item =>
            _.get(item, "Qty", 0)
          ) + push.UnderQty
    return (
      <>
        <table className="table table-board-order table-striped">
          <thead>
            <tr className="title-row">
              <th className="sell-cell title-cell">売気配数量</th>
              <th className="mark-cell" />
              <th className="center-cell">気配値</th>
              <th className="mark-cell" />
              <th className="buy-cell title-cell">買気配数量</th>
            </tr>
            {this.props.length === 10 && (
              <tr className="nariyuki-row">
                <th className="number-cell">
                  {Formatter.number(
                    push.MarketAskQty,
                    0,
                    "floor",
                    false,
                    "",
                    true
                  )}
                </th>
                <th className="mark-cell" />
                <th className="center-cell">成行</th>
                <th className="mark-cell" />
                <th className="number-cell">
                  {Formatter.number(
                    push.MarketBidQty,
                    0,
                    "floor",
                    false,
                    "",
                    true
                  )}
                </th>
              </tr>
            )}
            <tr className="over-row">
              <th className="number-cell">
                {Formatter.number(CalcOverQty, 0, "floor", false, "", true)}
              </th>
              <th className="mark-cell" />
              <th className="center-cell">OVER</th>
              <th className="mark-cell" />
              <th className="number-cell" />
            </tr>
          </thead>
          <tbody>
            {finalLength >= 10 && this.renderAsk(9)}
            {finalLength >= 9 && this.renderAsk(8)}
            {finalLength >= 8 && this.renderAsk(7)}
            {finalLength >= 7 && this.renderAsk(6)}
            {finalLength >= 6 && this.renderAsk(5)}
            {finalLength >= 5 && this.renderAsk(4)}
            {finalLength >= 4 && this.renderAsk(3)}
            {finalLength >= 3 && this.renderAsk(2)}
            {finalLength >= 2 && this.renderAsk(1)}
            {finalLength >= 1 && (
              <tr>
                <td className="buy-sell-price-cell sell-cell number-cell">
                  <span
                    className={ClassNames({
                      sell: _.get(push, "DepthOfAskPrice[0].Qty"),
                    })}
                  >
                    {Formatter.number(
                      _.get(push, "DepthOfAskPrice[0].Qty"),
                      0,
                      "floor",
                      false,
                      "-",
                      true
                    )}
                  </span>
                </td>
                <td className="mark-cell">
                  <span className={ClassNames({ sell: push.AskQuoteFlag })}>
                    {_.get(
                      _.find(QUOTE_FLAG_LIST, { code: push.AskQuoteFlag }),
                      "disp"
                    )}
                  </span>
                </td>
                <td className="center-cell">
                  <span
                    className={ClassNames({
                      buy: _.get(push, "DepthOfAskPrice[0].Price"),
                    })}
                  >
                    {Formatter.number(
                      _.get(push, "DepthOfAskPrice[0].Price"),
                      Symbol.NumberOfDecimals,
                      "floor",
                      false,
                      "-",
                      true
                    )}
                  </span>
                </td>
                <td className="mark-cell" />
                <td className="buy-sell-price-cell buy-cell number-cell" />
              </tr>
            )}
            {finalLength >= 1 && (
              <tr>
                <td className="buy-sell-price-cell sell-cell number-cell" />
                <td className="mark-cell" />
                <td className="center-cell">
                  <span
                    className={ClassNames({
                      sell: _.get(push, "DepthOfBidPrice[0].Price"),
                    })}
                  >
                    {Formatter.number(
                      _.get(push, "DepthOfBidPrice[0].Price"),
                      Symbol.NumberOfDecimals,
                      "floor",
                      false,
                      "-",
                      true
                    )}
                  </span>
                </td>
                <td className="mark-cell">
                  <span className={ClassNames({ buy: push.BidQuoteFlag })}>
                    {_.get(
                      _.find(QUOTE_FLAG_LIST, { code: push.BidQuoteFlag }),
                      "disp"
                    )}
                  </span>
                </td>
                <td className="buy-sell-price-cell buy-cell number-cell">
                  <span
                    className={ClassNames({
                      buy: _.get(push, "DepthOfBidPrice[0].Qty"),
                    })}
                  >
                    {Formatter.number(
                      _.get(push, "DepthOfBidPrice[0].Qty"),
                      0,
                      "floor",
                      false,
                      "-",
                      true
                    )}
                  </span>
                </td>
              </tr>
            )}
            {finalLength >= 2 && this.renderBid(1)}
            {finalLength >= 3 && this.renderBid(2)}
            {finalLength >= 4 && this.renderBid(3)}
            {finalLength >= 5 && this.renderBid(4)}
            {finalLength >= 6 && this.renderBid(5)}
            {finalLength >= 7 && this.renderBid(6)}
            {finalLength >= 8 && this.renderBid(7)}
            {finalLength >= 9 && this.renderBid(8)}
            {finalLength >= 10 && this.renderBid(9)}
          </tbody>
          <tfoot>
            <tr className="under-row">
              <th className="buy-sell-price-cell number-cell" />
              <th className="mark-cell" />
              <th className="center-cell">UNDER</th>
              <th className="mark-cell" />
              <th className="buy-sell-price-cell number-cell">
                {Formatter.number(CalcUnderQty, 0, "floor", false, "", true)}
              </th>
            </tr>
          </tfoot>
        </table>
      </>
    )
  }
}
